import '../styles/BottomNav.css';
import Button from '../layouts/Button';

export default function BottomNav() {

    return(

        <>

            <div className='bottom_c'>

                <h2>Vamos criar algo juntos?</h2>

                <div className='bottom_line'></div>

                <Button to='/contato' text='Fale comigo' />

            </div>

        </>

    )

}